import { createFileRoute } from '@tanstack/react-router'

import { RulesPageSkeleton } from '#/modules/ai/back-office/rules-page/rules-page-skeleton.tsx'
import { RulesPage } from '#/modules/ai/back-office/rules-page/rules-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai-underwriting/rules/')({
  beforeLoad: (options) => requirePermissions(options, ['subscriptionUnderwriting.act']),
  loader: ({ context: { queryClient, trpc } }) =>
    queryClient.ensureQueryData(trpc.aiUnderwriting.listRuleBookProducts.queryOptions()),
  pendingComponent: RulesPageSkeleton,
  component: RulesPage,
})
